import { Injectable } from '@angular/core';
import { PopulationStore } from './population.store';
import { Population } from './population.model';
import { ApiService } from '../../shared/services/core/api.service';
import { tap, mapTo } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class PopulationService {
  constructor(private populationStore: PopulationStore, private api: ApiService) {}

  fetchPopulations(clubId: number = 1) {
    return this.api.get<Population>(`populations/${clubId}`).pipe(
      tap(x => this.populationStore.set(x)),
      mapTo(null)
    );
  }
}
